export default {
  // 新增采购订单
  insertYcPurchaseOrder: '/ygsjzs/ycnPurchaseOrder/insertYcnPurchaseOrder',
  // 修改采购订单
  updateYcPurchaseOrder: '/ygsjzs/ycnPurchaseOrder/updateYcnPurchaseOrder',
  // 删除采购订单
  deleteYcPurchaseOrder: '/ygsjzs/ycnPurchaseOrder/deleteYcnPurchaseOrder',
  // 查询采购订单详情
  selectYcPurchaseOrderByOrderId: '/ygsjzs/ycnPurchaseOrder/selectYcnPurchaseOrderByOrderId',
  // 查询采购订单列表
  selectYcPurchaseOrderByList: '/ygsjzs/ycnPurchaseOrder/selectYcnPurchaseOrderByPage',
  // 审批采购订单
  approveYcnPurchaseOrder: '/ygsjzs/ycnPurchaseOrder/approveYcnPurchaseOrder',
  // 采购订单统计
  selectYcPurchaseOrderCount: '/ygsjzs/ycnSupplierPrice/selectYcnPurchaseOrderCount',
  // 采购订单统计（小程序）
  selectYcnPurchaseOrder: '/ygsjzs/ycnPurchaseOrder/selectYcnPurchaseOrder',
  // 采购订单统计导出
  exportYcnPurchaseOrder: '/ygsjzs/ycnPurchaseOrder/exportYcnPurchaseOrder',
  // 数量统计
  selectYcnPurchaseSpecByList: '/ygsjzs/ycnPurchaseOrder/selectYcnPurchaseSpecByList',
  // 采购单磅单
  selectYcnDeliverySpecByPage: '/ygsjzs/ycnDelivery/selectYcnDeliverySpecByPage'
}
